import React from 'react';
import { Chart as ChartJS, ArcElement, Legend, Title, Tooltip } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Legend, Title, Tooltip);

const PieChart = React.forwardRef((props, ref) => {
    const options = {
        maintainAspectRatio: true,
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            title: {
                display: true,
                text: props.text,
            },
        },
    };

    return <Pie ref={ref} data={props.data} options={options} />;
});

export default PieChart;
